module.exports = __webpack_public_path__ + "static/img/1-5.5331752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/1-5.jpg
// module id = QkEl
// module chunks = 25